import { HEADER_HEIGHT }  from '@/TokamapEditor/ux/constants';
import View               from '@widesk-ui/components/View';
import Logo               from '@/components/Logo';
import HeaderTitle        from '@/TokamapEditor/ux/Header/HeaderTitle';
import Link               from '@widesk-ui/components/Link';
import PublishButton      from '@/TokamapEditor/ux/Header/PublishButton';
import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';
import SaveStatusBanner   from './SaveStatusBanner';
import SelectionCount     from '@/TokamapEditor/ux/Header/SelectionCount';
import PreviewButton      from '@/TokamapEditor/ux/Header/PreviewButton';
import HistoryButton      from '@/TokamapEditor/ux/Header/HistoryButton';
import NotificationButton from './NotificationButton';
// Menu « Tâches » masqué temporairement.
// import TasksButton        from './TasksButton';
import ThemeToggleButton  from './ThemeToggleButton';
import Users              from './Users';
import UserMenu           from './UserMenu';
import useDesignTokens    from '@/hooks/useDesignTokens';
import Divider            from '@widesk-ui/components/Divider';
import { observer }       from 'mobx-react-lite';
import ShareButton        from '@/TokamapEditor/ux/Header/ShareButton';

const Header = observer(() => {
	const tokens = useDesignTokens();

	return (
		<View
			bg={tokens.nav.bg}
			className="editor-header"
			color="white"
			minH={HEADER_HEIGHT}
			center
			row
			spread
			px="md"
			zIndex={1001}
			// La pastille du centre de notifications est repeinte par une règle dédiée dans
			// `src/index.scss`, accrochée à `editor-header` — passer par une variable CSS héritée n'a pas
			// fonctionné ici.
			style={{ borderBottom: `1px solid rgba(255,255,255,0.08)` }}
		>
			<View gap="md" row center>
				<View w={40}>
					<Link to="/">
						<Logo short />
					</Link>
				</View>

				<HeaderTitle />

				<SaveStatusBanner instance={currentEditorStore.get} />
			</View>

			<View row gap="md" center>
				<SelectionCount instance={currentEditorStore.get} />

				<View row gap="xs" center>
					<HistoryButton />

					<PreviewButton />

					<PublishButton />

					<ShareButton />
				</View>

				{currentEditorStore.isCenterDefined && (
					<Divider type="vertical" style={{ height: 24, margin: 0, borderColor: 'rgba(255,255,255,0.32)' }} />
				)}

				<ThemeToggleButton />

				{/* <TasksButton /> */}

				<NotificationButton />

				<Users />

				{/* Sépare la présence des autres (rangée d'avatars) de ce qui concerne VOTRE compte —
				    deux notions voisines qu'un simple espacement ne distinguait pas. Même filet que
				    celui qui isole déjà le bloc publication, à gauche. */}
				<Divider type="vertical" style={{ height: 24, margin: 0, borderColor: 'rgba(255,255,255,0.32)' }} />

				<UserMenu />
			</View>
		</View>
	);
});

export default Header;